import { render, staticRenderFns } from "./EvaluacionRespetoPrincipiosValoresDialogComponent.vue?vue&type=template&id=672bdf43&scoped=true"
import script from "./EvaluacionRespetoPrincipiosValoresDialogComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionRespetoPrincipiosValoresDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionRespetoPrincipiosValoresDialogComponent.vue?vue&type=style&index=0&id=672bdf43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672bdf43",
  null
  
)

export default component.exports